import { useEffect, useState } from 'react';

import RadioGroup from '@components/radio-button/RadioGroup';
import { PaymentCollectionType } from '@features/group-management/constants';
// import { getDayType } from '@features/group-management/helper';
// import { getLastDayOfMonthUTC } from '@utils/date';
import { CardProps } from 'types/payment-options';

import { monthCardOptions, MonthDay } from '../constants';
import { getDefaultCustomDay, isFirstDayFrequencyEquivalent } from '../helper';
// import { handleMonthDateSelect } from '../helper';

const MonthCard = ({
  handleActivationDate,
  selectedDate,
  type,
  handleIntervalFrequency,
  hideFirstDayFrequency
}: // isPaymentLinkSent
CardProps) => {
  const [selectedDay, setSelectedDay] = useState<string>('');
  const [selectedType, setSelectedType] = useState('');

  const isFirstDayAlreadyInUse =
    type === PaymentCollectionType.MONTHLY &&
    isFirstDayFrequencyEquivalent(selectedDate);
  const shouldHideFirstDayFrequency =
    hideFirstDayFrequency && !isFirstDayAlreadyInUse;

  const handleDayClick = (item: string) => {
    setSelectedType(MonthDay.CUSTOM);
    setSelectedDay(item);
    // const { nextDueDate, isFutureDate } = handleMonthDateSelect({
    //   item,
    //   isPaymentLinkSent
    // });
    // handleActivationDate(new Date(nextDueDate), isFutureDate);
    handleActivationDate(item);
    handleIntervalFrequency('1');
  };

  const handleTypeSelect = (item: string) => {
    setSelectedType(item);
    if (item === MonthDay.CUSTOM) {
      const defaultDay = getDefaultCustomDay(shouldHideFirstDayFrequency);
      setSelectedDay(defaultDay);
      // const { nextDueDate, isFutureDate } = handleMonthDateSelect({
      //   item: '1',
      //   isPaymentLinkSent
      // });
      // handleActivationDate(new Date(nextDueDate), isFutureDate);
      handleActivationDate(defaultDay);
      handleIntervalFrequency('1');
    } else setSelectedDay('');
    if (item === MonthDay.LAST) {
      // const lastDay = getLastDayOfMonthUTC();
      // handleActivationDate(lastDay);
      handleActivationDate('last_day');
      handleIntervalFrequency('1');
    }
    if (item === MonthDay.FIRST) {
      // const { nextDueDate, isFutureDate } = handleMonthDateSelect({
      //   item: '1',
      //   isPaymentLinkSent
      // });
      // handleActivationDate(new Date(nextDueDate), isFutureDate);
      handleActivationDate('first_day');
      handleIntervalFrequency('1');
    }
  };

  useEffect(() => {
    if (!selectedDate || type !== PaymentCollectionType.MONTHLY) {
      if (shouldHideFirstDayFrequency) {
        setSelectedType(MonthDay.LAST);
        handleActivationDate('last_day');
        handleIntervalFrequency('1');
      } else {
        setSelectedType(MonthDay.FIRST);
        handleActivationDate('first_day');
        handleIntervalFrequency('1');
      }

      // const { nextDueDate, isFutureDate } = handleMonthDateSelect({
      //   item: '1',
      //   isPaymentLinkSent
      // });
      // handleActivationDate(new Date(nextDueDate), isFutureDate);
      // handleIntervalFrequency('');
    } else if (selectedDate && type === PaymentCollectionType.MONTHLY) {
      // const dayType = getDayType(selectedDate);
      // setSelectedType(dayType);
      if (selectedDate === 'first_day') {
        setSelectedType(MonthDay.FIRST);
        handleActivationDate('first_day');
        handleIntervalFrequency('1');
      } else if (selectedDate === 'last_day') {
        setSelectedType(MonthDay.LAST);
        handleActivationDate('last_day');
        handleIntervalFrequency('1');
      } else {
        setSelectedType(MonthDay.CUSTOM);
        handleActivationDate(selectedDate as string);
        handleIntervalFrequency('1');
        setSelectedDay(selectedDate as string);
      }
      // if (dayType === MonthDay.CUSTOM) {
      //   const day = new Date(selectedDate).getDate();
      //   setSelectedDay(String(day));
      // }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);

  const visibleMonthCardOptions = shouldHideFirstDayFrequency
    ? monthCardOptions.filter((option) => option.key !== MonthDay.FIRST)
    : monthCardOptions;

  const visibleDays = Array.from({ length: 28 }, (_, i) => i + 1).filter(
    (day) => !(shouldHideFirstDayFrequency && day === 1)
  );

  return (
    <>
      <RadioGroup
        options={visibleMonthCardOptions}
        handleChange={handleTypeSelect}
        orientation="vertical"
        selectedValue={selectedType}
        labelStyle="!text-cofeeNeutral10"
      />
      <div className="grid grid-cols-7 gap-2 pb-6 pt-1">
        {visibleDays.map((day) => (
          <div
            key={day}
            className={`flex size-[46px] cursor-pointer items-center justify-center rounded-lg border border-cofeeGreyBlue4 text-content ${
              Number(selectedDay) === day
                ? 'border-cofeePrimary6 bg-cofeeGreen1'
                : ''
            }`}
            role="presentation"
            onClick={() => handleDayClick(String(day))}
          >
            {day}
          </div>
        ))}
      </div>
    </>
  );
};

export default MonthCard;
